﻿import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import controller from '../../../../Resources/Scripts/_Shared/controller';
import { getUniqueVehicles } from '../../../../Resources/Scripts/_Shared/helpers';
import { vehicles } from './Endpoints';
import { permits } from './Endpoints';
import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history';
import VehicleListItem from './MyAimoParkVehicleListItem';
import { digitalPermits } from '../../MyAimoParkDigitalPermitsPage/Scripts/Endpoints';
import { validateFormObject } from '../../BookingFlowPage/Scripts/Validation'

function VehicleList(context) {
  const appContainer = context;
  const appConfig = controller.getConfig(context);
  const App = () => {
    const dataFromCshtml = appConfig.permit ?? appConfig.digitalPermit;
    const lang = appConfig.localization;
    const currentCountry = document.querySelector('html').getAttribute('country');
    const defaultCountryCode = currentCountry === 'no' ? 'N' : currentCountry === 'se' ? 'S' : 'FIN';
    const defaultCountryCodes = [{ Id: 'S', Name: 'S' }, { Id: 'FIN', Name: 'FIN' }, { Id: 'N', Name: 'N' }, { Id: 'DK', Name: 'DK' }];
    const countryCodeOptions = [
      ...defaultCountryCodes.filter(cc => cc.Id === defaultCountryCode),
      ...defaultCountryCodes.filter(cc => cc.Id !== defaultCountryCode),
    ];
    for (const [value] of Object.entries(lang.licenseplatecountrycodeoptions)) {
      if (value !== 'FIN' && value !== 'N' && value !== 'S' && value !== 'N' && value !== 'DK') countryCodeOptions.push({ Id: value, Name: value });
    };
    const countryCode = null;
    const unSelectedItem = ({ item: { Text: lang.notselected, Id: lang.notselected, IsUnselected: true } });
    const addNewLicensePlateItem = ({ item: { Text: lang.addnewvehicle, Id: 'NEW', IsNewLicensePlate: true, PlateText: "" } });
    const isSeasonTicket = appConfig.permit != undefined && appConfig.permit != null; // if permit ticket is false, the item is a digital permit
    const isSkidataPermit = dataFromCshtml.usageType == "SKIDATA";
    const isCustomerPermit = dataFromCshtml.usageType == "CUSTOMER";

    // If the ticket is reserved, any numbers of vehicles can be added. Otherwise, only up to quantity.
    const isReserved = dataFromCshtml.isReserved && dataFromCshtml.isReserved === 'True' ? true : false;
    const maxLicensePlates = dataFromCshtml.maxLicensePlates ? Number(dataFromCshtml.maxLicensePlates) : 1;
    const pooling = !!(maxLicensePlates > 1);
    const [pending, setPending] = useState(false);
    const [showSuccessfulPost, setShowSuccessfulPost] = useState(false);
    const [error, setError] = useState(null);
    const [validationError, setValidationError] = useState(null);
    const [validationErrors, setValidationErrors] = useState([]);
    const [vehiclesOnUser, setVehiclesOnUser] = useState([]);
    const [showEditingMode, setShowEditingMode] = useState(dataFromCshtml && (dataFromCshtml.licensePlates === "" || JSON.parse(dataFromCshtml.licensePlates).length === 0) ? true : false);
    const [shownNumberOfRows, setShownNumberOfRows] = useState(dataFromCshtml.licensePlates ? (JSON.parse(dataFromCshtml.licensePlates).length > 0 ? JSON.parse(dataFromCshtml.licensePlates).length : 1) : 1);

    // These vehicles are already on the ticket/permit and are obtained from the CSHTML
    const [vehiclesOnItem, setVehiclesOnItem] = useState(dataFromCshtml.licensePlates ? JSON.parse(dataFromCshtml.licensePlates).map(lp => ({ item: { Description: '', Text: '', Id: (lp.CountryCode ?? '') + ':' + lp.PlateText, PlateText: lp.PlateText, CountryCode: lp.CountryCode } })) : []);

    // These vehicles are all of the vehicles from vehiclesOnItem combined with vehicles from API-call getCustomerVehicles()
    const [vehiclesOnItemAndUser, setVehiclesOnItemAndUser] = useState([]);

    // These are the vehicles posted to the back-end. While the lists above cannot be changed by the user, this list will be changed as the user selects vehicles
    const [vehiclesToPost, setVehiclesToPost] = useState([]);

    const [quantity, setQuantity] = useState(dataFromCshtml.quantity ? JSON.parse(dataFromCshtml.quantity) : 1);
    const [originalLicensePlates, setOriginalLicensePlates] = useState([]);

    /**
     * Gets all vehicles on the user, which are then used to populate the dropdowns
     */
    useEffect(() => {
      let isSubscribed = true;

      const getUserVehicleList = async () => {
        setPending(true);
        const allUserVehicles = await vehicles.getCustomerVehicles({ bookingController: "/booking/" }, false, lang.language);

        if (allUserVehicles.status === 200 && isSubscribed && allUserVehicles.body !== null && allUserVehicles.body.length > 0) {
          setVehiclesOnUser(allUserVehicles.body)
          const userVehicles = [];
          for (let i = 0; i < allUserVehicles.body.length; i++) {
            const singleVehicle = allUserVehicles.body[i];

            userVehicles.push({
              item: {
                Id: singleVehicle.Id,
                PlateText: singleVehicle.LicensePlate.PlateText,
                CountryCode: singleVehicle.LicensePlate.CountryCode,
                Description: singleVehicle.Name,
                Text: singleVehicle.Name ? `${singleVehicle.LicensePlate.PlateText} (${singleVehicle.Name})` : singleVehicle.LicensePlate.PlateText,
              }
            });
          }
          const vehiclesOnItemWithAddedId = userVehicles.filter(uv => vehiclesOnItem.find(voi => voi.item.PlateText === uv.item.PlateText))
          const vehiclesNotOnUser = vehiclesOnItemWithAddedId.length != vehiclesOnItem.length ? vehiclesOnItem.filter(voi => !userVehicles.find(uv => uv.item.PlateText === voi.item.PlateText)).map(vehicle => ({ item: { ...vehicle.item, Text: vehicle.item.PlateText, Id: vehicle.item.Id } })) : [];
          const allLicensePlatesOnItem = getUniqueVehicles([...vehiclesOnItemWithAddedId, ...vehiclesNotOnUser]);

          if (vehiclesOnItemWithAddedId.length || vehiclesNotOnUser.length) setVehiclesOnItem(allLicensePlatesOnItem);
          const allLicensePlatesToShow = getUniqueVehicles([...vehiclesOnItemWithAddedId, ...userVehicles, ...vehiclesNotOnUser]);

          setVehiclesOnItemAndUser(allLicensePlatesToShow);
          setVehiclesToPost(allLicensePlatesOnItem);
          setOriginalLicensePlates(allLicensePlatesOnItem);

          setPending(false);

        } else if (allUserVehicles.status !== 200 && isSubscribed) {
          setError(allUserVehicles.errorMessage)
          setPending(false);

        } else if (isSubscribed) {
          const allLicensePlatesToShow = vehiclesOnItem && vehiclesOnItem.length > 0 ? vehiclesOnItem.map(vehicle => ({ item: { ...vehicle.item, Text: vehicle.item.PlateText } })) : [];
          setVehiclesOnItemAndUser(allLicensePlatesToShow);
          setVehiclesToPost(allLicensePlatesToShow);
          setVehiclesOnItem(allLicensePlatesToShow);
          setError(allUserVehicles.errorMessage)
          setPending(false);
        }
      }
      getUserVehicleList();
      return () => isSubscribed = false;
    }, []);

    /**
     * Add and remove vehicles from the final list of permits/tickets, meaning
     * the list of permits/tickets that is submitted
     */
    const updateVehiclesToPost = (oldLicensePlate, newLicensePlate = undefined) => {
      let newList = vehiclesToPost;

      //if (!originalLicensePlates.length) setOriginalLicensePlates(newList);
      if (newLicensePlate === undefined || newLicensePlate.item.IsNewLicensePlate || (newLicensePlate.item.Text !== undefined && newLicensePlate.item.Text === "") || (newLicensePlate.item.LicensePlate !== undefined && newLicensePlate.item.LicensePlate === "")) {
        newList = deleteFromVehiclesToPost(newList, oldLicensePlate);
      }
      else if (oldLicensePlate === undefined || oldLicensePlate.item.IsNewLicensePlate) {
        newList = addToVehiclesToPost(newList, newLicensePlate);
      }
      else {
        newList = deleteFromVehiclesToPost(newList, oldLicensePlate);
        newList = addToVehiclesToPost(newList, newLicensePlate);
      }
      setVehiclesToPost(newList);
      clearMessages();
    }

    const addToVehiclesToPost = (listOfLicensePlates, newLicensePlate) => {
      return ([...listOfLicensePlates, newLicensePlate]);
    }

    const deleteFromVehiclesToPost = (listOfLicensePlates, oldLicensePlate) => {
      const oldLicensePlateId = oldLicensePlate.item.Id;
      const oldLicensePlateText = oldLicensePlate.item.PlateText;
      let vehiclesToRemoveOneOf = listOfLicensePlates.filter((x) => vehicleIsEqualTo(x, oldLicensePlateId, oldLicensePlateText));
      if (vehiclesToRemoveOneOf.length === 1) {
        return listOfLicensePlates.filter((x) => !vehicleIsEqualTo(x, oldLicensePlateId, oldLicensePlateText));
      }
      else if (vehiclesToRemoveOneOf.length > 1) {
        vehiclesToRemoveOneOf = vehiclesToRemoveOneOf.slice(0, vehiclesToRemoveOneOf.length - 1);
        return ([...listOfLicensePlates.filter((x) => !vehicleIsEqualTo(x, oldLicensePlateId, oldLicensePlateText)), ...vehiclesToRemoveOneOf]);
      }
      return listOfLicensePlates;
    }

    const vehicleIsEqualTo = (vehicle, oldLicensePlateId, oldLicensePlateText) => {
      const vehicleId = vehicle.item.Id;
      const vehicleText = vehicle.item.PlateText;
      return (vehicleId === oldLicensePlateId || vehicleId === addNewLicensePlateItem.item.Id) && vehicleText === oldLicensePlateText;
    }

    const updateVehicleToUser = async (newVehicles) => {
      if (!newVehicles) return;
      let updateUserVehicleList = false;
      for (const vehicle of newVehicles) {
        if (!vehicle) return;
        const updateOrCreate = vehicle.form.vehicleId ? vehicles.updateCustomerVehicle : vehicles.createCustomerVehicle;
        const response = await updateOrCreate({ bookingController: "/booking/", ...vehicle }, false, lang.language);
        if (response.status === 200) updateUserVehicleList = true;
        else setError(response.errorMessage);
      }
      if (!updateUserVehicleList) return;
      const updatedUserVehicles = await vehicles.getCustomerVehicles({ bookingController: "/booking/" }, false, lang.language);
      if (updatedUserVehicles.status === 200 && updatedUserVehicles.body !== null && updatedUserVehicles.body.length > 0) setVehiclesOnUser(updatedUserVehicles.body);
    }

    const handleConfirm = async () => {
      clearMessages();

      setValidationErrors([]);
      const tempValidationErrors = [];

      vehiclesToPost.forEach((vehicle) => {
        if (vehicle.item.Id === 'NEW') { 
          const lp = {
            licensePlate: { value: { text: vehicle.item.PlateText, elementType: 'licenseplate', multiple: true, error: null, countryCode: vehicle.item.CountryCode } }
          }
          let [formValidationError, cleanFormData] = validateFormObject(lp, lang, lang.currentcountry);
          if (formValidationError) tempValidationErrors.push({ error: cleanFormData.licensePlate.error, licensePlate: vehicle.item.PlateText, validation: true })
        }
      });

      if (tempValidationErrors.length) {
        setValidationErrors(tempValidationErrors)
        return
      }

      if (isSeasonTicket && !vehiclesToPost.some(vehicle => vehicle.item?.PlateText)) {
        setValidationError({
          error: lang.required
        })
        return
      }

      setPending(true);

      const postedVehicles = getUniqueVehicles(vehiclesToPost.filter(v => !v.item.IsUnselected && v.item.PlateText).reverse()).reverse();
      const params = {
        orderId: (dataFromCshtml.orderId !== "" ? dataFromCshtml.orderId : null),
        orderLineIdAndVersion: dataFromCshtml.orderLineIdAndVersion,
        permitId: dataFromCshtml.id,
        uid: dataFromCshtml.landlordPortalUid,
        data: {
          registrationPlates: postedVehicles.map(vehicle => {
            const oldCountryCode = vehicle.item.CountryCode && isNaN(vehicle.item.CountryCode) ? vehicle.item.CountryCode.toLowerCase() : null;
            const parsedCountryCode = oldCountryCode ? oldCountryCode === 'se' ? 'S' : oldCountryCode === 'fi' ? 'FIN' : oldCountryCode === 'no' ? 'N' : null : null;
            return { plateText: vehicle.item.PlateText, countryCode: parsedCountryCode ?? vehicle.item.CountryCode ?? countryCode }
          })

          //name: vehicle.item.Text, licensePlate: { plateText: vehicle.item.PlateText, countryCode: parsedCountryCode ?? vehicle.item.CountryCode ?? countryCode }
        }
      }
      const response = isSeasonTicket ? await permits.updatePermit(params, lang.language) : await digitalPermits.updatePermit(params, lang.language);

      if (response.status === 200) {
        const newVehicles = postedVehicles.map(vehicle => {
          if (!vehiclesOnUser.some(userVehicle => userVehicle.LicensePlate.PlateText === vehicle.item.PlateText)) {
            return {
              form: { name: vehicle.item.Description ?? '', licensePlate: { plateText: vehicle.item.PlateText, countryCode: vehicle.item.CountryCode } }
            }
          }
        }).filter(vehicle => vehicle != undefined)

        const vehiclesWithNewDescription = postedVehicles.map(vehicle => {
          return vehiclesOnUser.map(userVehicle => {
            if (userVehicle.LicensePlate.PlateText === vehicle.item.PlateText && (userVehicle.Description != vehicle.item.Description)) {
              const existingPlateText = userVehicle.LicensePlate.PlateText;
              const existingId = userVehicle.Id;
              return {
                form: {
                  vehicleId: existingId, data: { name: vehicle.item.Description, licensePlate: { plateText: existingPlateText, countryCode: vehicle.item.CountryCode } }
                }
              }
            }
          }).filter(vehicle => vehicle != undefined)[0];
        }).filter(vehicle => vehicle != undefined);

        await updateVehicleToUser(newVehicles);
        await updateVehicleToUser(vehiclesWithNewDescription);
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('reload')) {
          urlParams.append('reload', true)
          let newUrl = window.location.origin + window.location.pathname;
          newUrl += '?' + urlParams.toString()
          history.replaceState(paramsToObject(urlParams), document.title, newUrl);
        }

        setTimeout(() => {
          setPending(false);
          setShowEditingMode(false);
          setVehiclesOnItem(postedVehicles);
          setOriginalLicensePlates(postedVehicles);
          setVehiclesToPost(postedVehicles);
          setShownNumberOfRows(postedVehicles.length);

          if (vehiclesWithNewDescription.length > 0) {
            const filteredVehiclesOnItemAndUser = vehiclesOnItemAndUser.filter(voiau => postedVehicles.find(pv => pv.item.PlateText != voiau.item.PlateText))
            setVehiclesOnItemAndUser(getUniqueVehicles([...filteredVehiclesOnItemAndUser, ...postedVehicles]))
          }
          else setVehiclesOnItemAndUser(getUniqueVehicles([...vehiclesOnItemAndUser, ...postedVehicles]));
          setTimeout(() => setShowSuccessfulPost(true), 10);
        }, 500);
        return;
      }
      else {
        setTimeout(() => {
          setError(response.body.ErrorMessage);
          setPending(false);
        }, 250);
      }
    }

    const toggleEditingMode = (mode) => {
      if (mode === "cancel") {
        const vehicles = originalLicensePlates.length ? [...originalLicensePlates] : [...vehiclesToPost];
        setVehiclesToPost(vehicles);
        setOriginalLicensePlates(vehicles);
        setShownNumberOfRows(vehicles.length);
      }
      clearMessages();
      setShowEditingMode(!showEditingMode);
    }

    const clearMessages = () => {
      if (showSuccessfulPost === true) {
        setShowSuccessfulPost(false);
      }
      setValidationError(null);
      setError(null);
    }
    const createRow = (uniqueKey, licensePlate = unSelectedItem, index) => {
      return !error && (
        <React.Fragment key={uniqueKey}>
          <VehicleListItem
            licensePlatesOnPermit={vehiclesOnItemAndUser}
            licensePlate={licensePlate}
            pending={pending}
            lang={lang}
            unSelectedItem={unSelectedItem}
            addNewLicensePlateItem={addNewLicensePlateItem}
            handleValueChange={updateVehiclesToPost}
            index={index}
            length={shownNumberOfRows - 1}
            showEditingMode={showEditingMode}
            isSeasonTicket={isSeasonTicket}
            isReserved={isReserved}
            pooling={pooling}
            error={validationError || validationErrors}
            setError={setValidationErrors}
            defaultCountryCode={defaultCountryCode}
            countryCodeOptions={countryCodeOptions}
          />
        </React.Fragment>
      );
    }

    // Creates rows for all licenses already on the permit, which are set as default in their respective dropdown
    let rows = vehiclesOnItem.length > 0 ?
      vehiclesOnItem.map((licensePlate, i) => {
        const reactKey = (licensePlate.item.PlateText ?? licensePlate.item.CountryCode ?? licensePlate.item.Text) + i;
        return (createRow(reactKey, licensePlate, i));
      }) : [];

    const handleDisplayAnotherRow = () => {
      clearMessages();
      setVehiclesToPost([...vehiclesToPost, unSelectedItem]);
      setShownNumberOfRows(shownNumberOfRows + 1);
    }

    // Creates additional rows if there are more vehicles allowed than that are already on the permit
    if (showEditingMode && (rows.length < quantity || isReserved || (pooling && shownNumberOfRows <= maxLicensePlates) )) {
      let additionalRows = [];
      let numberOfAdditionalRows = isReserved ? 100 : pooling ? (maxLicensePlates) : quantity - rows.length;

      for (var i = 0; i < numberOfAdditionalRows; i++) {
        additionalRows.push(createRow("extra-" + i, unSelectedItem, rows.length + i));
      }
      rows = [...rows, ...additionalRows];
    }

    return (
      <div className="myaimoparkdigitalpermits__overlay myaimoparkoverlay__overlay__bottom__inner">
        <h3>{lang.heading}</h3>

        {!isCustomerPermit && !isSkidataPermit && <p className="myaimoparkoverlay__overlay__bottom__info">{lang.admininapp}</p>}
        
        {isSkidataPermit && <p className="myaimoparkoverlay__overlay__bottom__info">{lang.nolicenseplateneeded}</p>}

        {isCustomerPermit && <p className="myaimoparkoverlay__overlay__bottom__info">{lang.customerlicenseplate}</p>}
        
        {!isSkidataPermit && !isCustomerPermit &&
        <div className="myaimoparkoverlay__overlay__bottom__list">
          {rows.slice(0, shownNumberOfRows)}
        </div>
        }

        {error &&
          <div className="myaimoparkoverlay__overlay__bottom__inner__error">
            <p dangerouslySetInnerHTML={{ __html: error }}></p>
          </div>
        }

        {showEditingMode && !isSkidataPermit && !isCustomerPermit && (!pooling && (rows.length > shownNumberOfRows) || isReserved || (pooling && shownNumberOfRows < maxLicensePlates)) && !error &&
          <div>
            <a href="#" onClick={() => handleDisplayAnotherRow()} className="myaimoparkoverlay__overlay__bottom__inner__link myaimoparkoverlay__overlay__bottom__inner__link__add-new">
              {lang.addvehicle}
            </a>
          </div>
        }

        {showEditingMode && !isSkidataPermit && !isCustomerPermit && 
          <div className="myaimoparkoverlay__overlay__bottom__inner__one-line-wrapper">
            {vehiclesOnItem.length > 0 &&
              <div className="myaimoparkoverlay__overlay__bottom__inner__button myaimoparkoverlay__overlay__bottom__inner__button--cancel">
                <button disabled={pending} aria-busy={pending} onClick={() => toggleEditingMode("cancel")}>
                  {lang.cancel}
                </button>
              </div>
            }
            <div className="myaimoparkoverlay__overlay__bottom__inner__button myaimoparkoverlay__overlay__bottom__inner__button--confirm">
              <button data-map-button={isSeasonTicket ? "confirm-vehicle-season-ticket" : "confirm-vehicle-digital-permit"} disabled={pending || error} aria-busy={pending} onClick={handleConfirm}>
                {lang.confirm}
              </button>
            </div>
          </div>
        }

        {!showEditingMode && !error && !isSkidataPermit && !isCustomerPermit &&
          <div className="myaimoparkoverlay__overlay__bottom__inner__wrapper-link">
            <a href="#" onClick={() => toggleEditingMode()} className="myaimoparkoverlay__overlay__bottom__inner__link myaimoparkoverlay__overlay__bottom__inner__link__edit">
              {lang.edit}
            </a>
          </div>
        }

        {showSuccessfulPost &&
          <div className="myaimoparkoverlay__overlay__bottom__inner__success">
            <p>{lang.success}</p>
          </div>
        }
      </div>)
  }

  function init() {
    ReactDOM.render(<App />, appContainer);
  }

  return {
    init
  };
}

controller.add('myaimopark-permits-vehicle-list', VehicleList);
controller.add('myaimopark-digital-permits-vehicle-list', VehicleList);
